import type { AssignmentScope } from '@Application/Ai/AiConfiguration/Assignments/AssignmentScope';
import { PermissionEnum } from '@Application/Security/Roles';

/** Only the account route enforces `AI_ACCOUNT_ASSIGNMENT_WRITE`; the other two share `AI_ASSIGNMENT_WRITE`. */
const writePermissionByScope: Readonly<Record<AssignmentScope['type'], PermissionEnum>> = Object.freeze({
	account: PermissionEnum.AI_ACCOUNT_ASSIGNMENT_WRITE,
	organization: PermissionEnum.AI_ASSIGNMENT_WRITE,
	facility: PermissionEnum.AI_ASSIGNMENT_WRITE,
});

export default writePermissionByScope;
